/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-06-14 19:46:58
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-28 17:47:34
 */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { requestFail, requestError } from '@/utils'
import { useAuthStore, useSettingStore } from '@/store'
import LangType from '@/utils/i18n/LangType'
import { objKeySort, deleteNullKey } from '@/utils/index'
import { Md5 } from 'ts-md5'
import HTTP_CODE_STATUS from '@/utils/httpCode'
import { message } from 'ant-design-vue'
const VITE_APP_API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL
const VITE_APP_SIGNKEY = import.meta.env.VITE_APP_SIGNKEY
export const getToken = () => {
  const authStore = useAuthStore()
  return authStore?.token
}
const signConfig= {
  key: 'signKey',
  key2: 'ts'
}
/**获取验签 */
const getTmpSign = (config: AxiosRequestConfig, _time: any) => {
  /**删除空值 */
  let params = deleteNullKey(config.data ? JSON.parse(config.data) : {})
  if (config.method === 'get') params = config.params ?? {}
  /**排序 */
  params = objKeySort(params)
  const reg = new RegExp('"', 'g')
  const reg2 = new RegExp(`'\''`, 'g')
  const key = `${JSON.stringify(params)}&${signConfig.key2}=${_time}&${signConfig.key}=${VITE_APP_SIGNKEY}`.replaceAll(reg, '').replace(reg2, '')
  return Md5.hashStr(key).toUpperCase()
}
const axiosInstance = axios.create({
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  baseURL: VITE_APP_API_BASE_URL
})


axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const { locale } = useSettingStore()
    const _time = new Date().getTime()
    if (config.method === 'get') {
      const data = config.params || {}
      config.data = JSON.stringify(data)
    }
    Object.assign(config.headers!, {
      authToken: getToken(),
      sysCode: 'ADMIN',
      ts: _time,
      language: LangType[locale],
      langType: LangType[locale],
      tmpSign: getTmpSign(config, _time)
    })
    return config
  },
  (error) => {
    return error
  }
)
// 响应拦截
axiosInstance.interceptors.response.use(
  (res: AxiosResponse) => {
    const NoAlert = res?.config?.headers?.NoAlert ?? false
    const { data } = res
    if (res.status === 200) {
      const SUCCESS_CODES = [
        HTTP_CODE_STATUS.SUCCESS,
        HTTP_CODE_STATUS.JTS_UPLOAD_SUCCESS,
        HTTP_CODE_STATUS.TIME_BACK_STATUS,
        HTTP_CODE_STATUS.JTS_SUCCESS,
        HTTP_CODE_STATUS.JTS_SUCCESS_CONFIRM
      ]
      if (data?.code && !SUCCESS_CODES.includes(data.code) && !NoAlert) requestFail(data)
    } else {
      message.error(data.msg)
    }
    return res
  },
  (err: AxiosError) => {
    requestError(err)
  }
)

export default axiosInstance
